/**
 * Owner: Masa Bayu
 * File: qx-studio-empty-boot.ts
 * Date:Time: 2026-10-29 11:38
 * Description: Studio buka naskhah kosong — buang sesi IndexedDB pelayar dikongsi.
 */

import {
  emptyQxeditorDocumentSnapshot,
  setQxeditorDocumentSnapshot,
} from '@qx/qxeditor-app/shell/qxeditor-document-store';
import { clearQxeditorSession } from '@qx/qxeditor-app/shell/qxeditor-session-store';
import { resetWriterDocumentToBlank } from '@qx/qxwriter-app/lib/qx-writer-document-store';
import { clearWriterSessionDraft } from '@qx/qxwriter-app/lib/qx-writer-session';

/**
 * Sesi draf Tulis ialah satu kunci IndexedDB per-asal, bukan per-akaun.
 * Naskhah QXW pada peranti tidak dibuang: itu salinan yang boleh disunting.
 */
export async function wipeSharedStudioSessions(): Promise<void> {
  setQxeditorDocumentSnapshot(emptyQxeditorDocumentSnapshot());
  resetWriterDocumentToBlank();
  clearWriterSessionDraft();
  await clearQxeditorSession();
}
